module.exports = __webpack_public_path__ + "static/media/profile_generic.c2e5366a.png";